import React from 'react'
import classnames from 'classnames'

const RadioGroup = ({ className, error, id, label, classic, ...props }) => {
  const classes = classnames(
    'radio-group',
    {
      'radio-group--invalid': !!error,
      'radio-group--classic': !!classic
    },
    className
  );

  return (
    label ? (
      <div className="input-group">
        <label className="form-label" htmlFor={id} error={error}>
          {label}
        </label>
        <div className={classes} {...props}>
          { props.children }
        </div>
      </div>
    ) : (
      <div className={classes} {...props}>
        { props.children }
      </div>
    )
  );
};

export default RadioGroup
